import type { ServiceError } from 'gpcore-apikit/grpc/types';
import { type FlavourRequest, useFlavourStore } from 'gpcore-apikit/store/pinia/flavour';
import { useProjectStore } from 'gpcore-apikit/store/pinia/project';
import { type Flavour, FlavourAvailability } from 'gpcore-grpc/gpcore/api/cloud/v1/flavour_pb';
import type { Datacenter } from 'gpcore-grpc/gpcore/api/cloud/v1/region_pb';
import useNotifications from 'gpcore-uikit/composables/useNotifications';
import { type MaybeRef, computed, ref, shallowRef, unref } from 'vue';

export default (datacenter: MaybeRef<Datacenter>) => {
  const flavourStore = useFlavourStore();
  const showSoldOut = ref(false);

  const projectStore = useProjectStore();
  const currentProject = computed(() => projectStore.project);

  const isLoading = ref(false);
  const flavours = shallowRef<Flavour[]>([]);
  const displayFlavours = computed(() => {
    // show all flavours if showSoldOut is true
    if (showSoldOut.value) {
      return flavours.value;
    }

    // filter out "out of stock" flavours
    return flavours.value.filter((fl) => fl.availability !== FlavourAvailability.OUT_OF_STOCK);
  });
  const { addNotification } = useNotifications();
  const error = ref<Error>(null);

  const fetch = async () => {
    const req: FlavourRequest = {
      datacenter: unref(datacenter),
      project: currentProject.value,
      includeSoldOut: showSoldOut.value,
      page: 1,
    };

    isLoading.value = true;
    flavours.value = [];

    try {
      const response = await flavourStore.reloadAllFlavours(req);
      flavours.value = response.flavours;
    } catch (e) {
      addNotification({
        message: (e as ServiceError).message,
        type: 'danger',
      });

      error.value = e as Error;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    fetch,
    isLoading,
    data: flavours,
    displayData: displayFlavours,
    error,

    showSoldOut,
  };
};
